import React from 'react';
import cn from 'classnames';
import { IconButton } from 'components';
import styles from './CancelButton.module.scss';

export interface CancelButtonProps {
  /** Custom class name */
  className?: string;
  /** on remove handler */
  onRemove: () => void | undefined;
  /** disable state */
  disabled?: boolean;
  /** hide/show button */
  isShow?: boolean;
  placeholderClassName?: string;
}

export const CancelButton: React.FC<CancelButtonProps> = ({
  disabled,
  onRemove,
  className,
  placeholderClassName,
  isShow,
}: CancelButtonProps) => {
  const buttonClassNames = cn(styles.CancelButton, className);
  const placeholderClassNames = cn(
    styles.CancelButtonPlaceholder,
    placeholderClassName
  );

  return (
    <div className={placeholderClassNames}>
      {isShow ? (
        <IconButton
          type="button"
          iconName="cancel"
          disabled={disabled}
          onClick={onRemove}
          className={buttonClassNames}
        />
      ) : null}
    </div>
  );
};

CancelButton.displayName = 'CancelButton';
